<!-- 商家端 - 商品管理 -->
<template>
  <!-- 搜索栏 -->
  <ContentWrap>
    <el-form
      ref="queryFormRef"
      :inline="true"
      :model="queryParams"
      class="-mb-15px"
      label-width="68px"
    >
      <el-form-item label="商品名称" prop="name">
        <el-input
          v-model="queryParams.name"
          class="!w-240px"
          clearable
          placeholder="请输入商品名称"
          @keyup.enter="handleQuery"
        />
      </el-form-item>
      <el-form-item label="审核状态" prop="auditStatus">
        <el-select v-model="queryParams.auditStatus" class="!w-160px" clearable placeholder="全部">
          <el-option
            v-for="item in auditStatusOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button @click="handleQuery"><Icon class="mr-5px" icon="ep:search" />搜索</el-button>
        <el-button @click="resetQuery"><Icon class="mr-5px" icon="ep:refresh" />重置</el-button>
        <el-button plain type="primary" @click="openForm(undefined)">
          <Icon class="mr-5px" icon="ep:plus" />新增商品
        </el-button>
        <el-button type="primary" @click="importRef?.open()">导入商城商品</el-button>
        <el-button type="success" plain :loading="exportLoading" @click="handleExport">
          <Icon class="mr-5px" icon="ep:download" />导出
        </el-button>
        <el-button type="warning" plain @click="openSaleableImport">
          <Icon class="mr-5px" icon="ep:upload" />导入可售更新
        </el-button>
        <el-button type="warning" plain @click="openCreateImport">
          <Icon class="mr-5px" icon="ep:upload" />导入新建商品
        </el-button>
      </el-form-item>
    </el-form>
  </ContentWrap>

  <!-- 列表 -->
  <ContentWrap>
    <el-tabs v-model="queryParams.tabType" @tab-change="handleTabChange">
      <el-tab-pane
        v-for="tab in tabsData"
        :key="tab.type"
        :label="`${tab.name}(${tab.count})`"
        :name="tab.type"
      />
    </el-tabs>
    <el-table v-loading="loading" :data="list" stripe>
      <el-table-column label="商品图片" width="100">
        <template #default="{ row }">
          <el-image :src="row.picUrl" class="h-60px w-60px" fit="cover" />
        </template>
      </el-table-column>
      <el-table-column label="商品名称" min-width="200" prop="name" show-overflow-tooltip />
      <el-table-column label="价格" width="120">
        <template #default="{ row }">{{ fenToYuan(row.price) }} 元</template>
      </el-table-column>
      <el-table-column label="库存" width="80" prop="stock" />
      <el-table-column label="销量" width="80" prop="salesCount" />
      <el-table-column label="审核状态" width="90">
        <template #default="{ row }">
          <el-tag v-if="row.auditStatus === 0" type="info" size="small">草稿</el-tag>
          <el-tag v-else-if="row.auditStatus === 1" type="warning" size="small">审核中</el-tag>
          <el-tag v-else-if="row.auditStatus === 2" type="success" size="small">审核通过</el-tag>
          <el-tag v-else-if="row.auditStatus === 3" type="danger" size="small">审核不通过</el-tag>
          <el-tag v-else-if="row.auditStatus === 4" type="success" size="small">已上架</el-tag>
          <el-tag v-else-if="row.auditStatus === 5" type="info" size="small">已下架</el-tag>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="上架状态" width="90">
        <template #default="{ row }">
          <el-tag v-if="row.status === ProductSpuStatusEnum.RECYCLE.status" type="info">
            回收站
          </el-tag>
          <el-tag v-else :type="row.status === 1 ? 'success' : 'info'">
            {{ row.status === 1 ? '上架' : '下架' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="审核备注" min-width="120" prop="auditRemark" show-overflow-tooltip />
      <el-table-column label="创建时间" width="170" prop="createTime" :formatter="dateFormatter" />
      <el-table-column label="操作" width="280" fixed="right">
        <template #default="{ row }">
          <template v-if="queryParams.tabType === 4">
            <el-button link type="primary" @click="handleRestore(row)">恢复</el-button>
            <el-button link type="danger" @click="handleDelete(row.id)">彻底删除</el-button>
          </template>
          <template v-else>
            <el-button link type="primary" @click="openForm(row.id)">编辑</el-button>
            <el-button
              v-if="row.auditStatus === 2 || row.auditStatus === 5"
              link
              type="success"
              :disabled="row.status === 1"
              @click="handlePutOnSale(row.id)"
            >
              上架
            </el-button>
            <el-button
              v-if="row.status === 1"
              link
              type="warning"
              @click="handlePutOffSale(row.id)"
            >
              下架
            </el-button>
            <el-button link type="danger" @click="handleRecycle(row)">回收</el-button>
          </template>
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      v-model:limit="queryParams.pageSize"
      v-model:page="queryParams.pageNo"
      :total="total"
      @pagination="getList"
    />
  </ContentWrap>
  <MallImportDialog ref="importRef" @success="handleImportSuccess" />


  <ProductExcelImportForm
    ref="saleableImportRef"
    title="导入可售更新"
    hint="流程：下载模板 → 按 SKU 改价/库存等 → 上传。勿改「SKU编号」。改最低销售价会触发重审并下架；只改库存等保持上架。任一失败整表不写入。"
    template-tip="模板=当前筛选下的可售 SKU 清单（带数据）"
    template-file-name="商品可售更新模板.xlsx"
    :download-template-api="downloadSaleableTemplate"
    :import-api="MerchantProductApi.importSaleableSpu"
    @success="refreshAfterImport"
  />
  <ProductExcelImportForm
    ref="createImportRef"
    title="导入新建商品"
    hint="流程：下载模板 → 按示例填写（同「导入分组键」多行=同一商品；多规格如 颜色:红;尺码:L）→ 上传。新建进入审核中。任一失败整表不写入。"
    template-tip="模板含表头与示例行（单规格/多规格）"
    template-file-name="新建商品导入模板.xlsx"
    :download-template-api="downloadCreateTemplate"
    :import-api="MerchantProductApi.importCreateSpu"
    @success="refreshAfterImport"
  />
</template>

<script setup lang="ts">
import MallImportDialog from './MallImportDialog.vue'
import * as MerchantProductApi from '@/api/merchant/product'
import { fenToYuan } from '@/utils'
import { dateFormatter } from '@/utils/formatTime'
import { ProductSpuStatusEnum } from '@/utils/constants'
import download from '@/utils/download'
import ProductExcelImportForm from '@/views/mall/product/spu/components/ProductExcelImportForm.vue'

defineOptions({ name: 'MerchantProductSpu' })

const importRef = ref<InstanceType<typeof MallImportDialog>>()
const handleImportSuccess = async () => {
  queryParams.tabType = 1
  queryParams.pageNo = 1
  queryParams.name = ''
  queryParams.auditStatus = undefined
  await refreshAll()
}
const message = useMessage()
const { push } = useRouter()

const loading = ref(false)
const exportLoading = ref(false)
const list = ref([])
const total = ref(0)
const queryParams = reactive({
  pageNo: 1,
  pageSize: 10,
  name: '',
  auditStatus: undefined as number | undefined,
  tabType: 0
})

const tabsData = ref([
  { name: '出售中', type: 0, count: 0 },
  { name: '仓库中', type: 1, count: 0 },
  { name: '已售罄', type: 2, count: 0 },
  { name: '警戒库存', type: 3, count: 0 },
  { name: '回收站', type: 4, count: 0 }
])

const auditStatusOptions = [
  { label: '草稿', value: 0 },
  { label: '审核中', value: 1 },
  { label: '审核通过', value: 2 },
  { label: '审核不通过', value: 3 },
  { label: '已上架', value: 4 },
  { label: '已下架', value: 5 }
]

const getTabsCount = async () => {
  try {
    const res = await MerchantProductApi.getTabsCount()
    for (const key in res) {
      const idx = Number(key)
      if (tabsData.value[idx]) {
        tabsData.value[idx].count = res[key]
      }
    }
  } catch {
    // 数量失败不阻断列表
  }
}

const getList = async () => {
  loading.value = true
  try {
    const data = await MerchantProductApi.getSpuPage(queryParams)
    list.value = data.list
    total.value = data.total
  } finally {
    loading.value = false
  }
}

const refreshAll = async () => {
  await getTabsCount()
  await getList()
}

const handleQuery = () => {
  queryParams.pageNo = 1
  getList()
}

const resetQuery = () => {
  queryParams.name = ''
  queryParams.auditStatus = undefined
  handleQuery()
}

const handleTabChange = (name: string | number) => {
  queryParams.tabType = Number(name)
  queryParams.pageNo = 1
  getList()
}

const openForm = (id?: number) => {
  push({ path: '/store/product/form', query: id ? { id } : {} })
}

const handleExport = async () => {
  try {
    await message.exportConfirm()
  } catch {
    return
  }
  exportLoading.value = true
  try {
    const data = await MerchantProductApi.exportSpu(queryParams)
    download.excel(data as Blob, '商品列表.xls')
  } finally {
    exportLoading.value = false
  }
}

/** 可售更新弹窗内「下载模板」 */
const downloadSaleableTemplate = () => MerchantProductApi.exportSaleableSpu(queryParams)

/** 新建商品弹窗内「下载模板」 */
const downloadCreateTemplate = () => MerchantProductApi.getCreateImportTemplate()

const saleableImportRef = ref<InstanceType<typeof ProductExcelImportForm>>()
const createImportRef = ref<InstanceType<typeof ProductExcelImportForm>>()
const openSaleableImport = () => saleableImportRef.value?.open()
const openCreateImport = () => createImportRef.value?.open()
const refreshAfterImport = async () => {
  await refreshAll()
}

const handlePutOnSale = async (id: number) => {
  try {
    await message.confirm('确认上架该商品？')
    await MerchantProductApi.putOnSale(id)
    message.success('上架成功')
    await refreshAll()
  } catch {}
}

const handlePutOffSale = async (id: number) => {
  try {
    await message.confirm('确认下架该商品？')
    await MerchantProductApi.putOffSale(id)
    message.success('下架成功')
    await refreshAll()
  } catch {}
}

const handleRecycle = async (row: any) => {
  try {
    await message.confirm(`确认将「${row.name}」移入回收站？`)
    await MerchantProductApi.updateStatus({
      id: row.id,
      status: ProductSpuStatusEnum.RECYCLE.status
    })
    message.success('已移入回收站')
    await refreshAll()
  } catch {}
}

const handleRestore = async (row: any) => {
  try {
    await message.confirm(`确认将「${row.name}」恢复到仓库？`)
    await MerchantProductApi.updateStatus({
      id: row.id,
      status: ProductSpuStatusEnum.DISABLE.status
    })
    message.success('已恢复到仓库')
    await refreshAll()
  } catch {}
}

const handleDelete = async (id: number) => {
  try {
    await message.delConfirm()
    await MerchantProductApi.deleteSpu(id)
    message.success('删除成功')
    await refreshAll()
  } catch {}
}

onMounted(() => {
  refreshAll()
})
</script>
